import React from 'react';
import { Col, Row } from 'react-flexbox-grid';
import { Button, Checkbox, Icon, InputGroup, Tooltip } from '@wfp/ui';
import { iconFilter } from '@wfp/icons';

import { Risk, Seriousness, seriousnessClass, seriousnessLabel } from '../../restapi/types';
import { RiskIcon } from '../common/RiskIcon';
import { useRiskLabels } from '../../hooks/home';

import "./FilterBox.scss";


interface Props {
	riskSet: Risk[];
	seriousnessSet: Seriousness[];
	onChange: (changes: { riskSet: Risk[], seriousnessSet: Seriousness[] }) => void;
}

const seriousnessChoices = [Seriousness.low, Seriousness.moderate, Seriousness.high, Seriousness.veryHigh];

export function FilterBox({riskSet, seriousnessSet, onChange}: Props) {
	const riskLabel = useRiskLabels();

	const count = riskSet.length + seriousnessSet.length;

	return (<div className="filter-box-container">
		<Tooltip trigger="click" placement="right-start"
				 createRefWrapper={true}
				 content={<div className="filter-box left">
					 <Row middle="xs" className="filter-header">
						 <Col xs>
							 <h4>Filters</h4>
						 </Col>
						 <Col xs className="right">
							 <Button kind="ghost" small
									 onClick={() => {
										 onChange({riskSet: [], seriousnessSet: []});
									 }}>Reset</Button>
						 </Col>
					 </Row>

					 <Row>
						 <Col xs>

							 <InputGroup
								 labelText="Risks" hideLabel
								 name="risks">
								 {(Object.keys(riskLabel) as Risk[]).map(r =>
									 <Checkbox
										 key={r}
										 id={`risks-${r}`}
										 name="risks"
										 className="risk-checkbox"
										 value={r}
										 labelText={<><RiskIcon risk={r}
																seriousness={Seriousness.notRelevant}/>{riskLabel[r]}</>}
										 checked={riskSet.includes(r)}
										 onChange={e => {
											 const others = riskSet.filter(o => o !== r);
											 const newRisks = e.target.checked ? [...others, r] : others;
											 onChange({riskSet: newRisks, seriousnessSet});
										 }}
									 />,
								 )}
							 </InputGroup>
						 </Col>

						 <Col xs>
							 <InputGroup
								 labelText="Seriousness" hideLabel
								 name="seriousness">
								 {seriousnessChoices.map(s =>
									 <Checkbox
										 key={s}
										 id={`seriousness-${s}`}
										 name="seriousness"
										 className="risk-checkbox"
										 value={s}
										 labelText={<div
											 className={`seriousness-radio ${seriousnessClass[s]}`}>{seriousnessLabel[s]}</div>}
										 checked={seriousnessSet.includes(s)}

										 onChange={e => {
											 const others = seriousnessSet.filter(o => o !== s);
											 const newSeriousness = e.target.checked ? [...others, s] : others;
											 onChange({riskSet, seriousnessSet: newSeriousness});
										 }}
									 />,
								 )}
							 </InputGroup>
						 </Col>
					 </Row>
				 </div>}>
			<div className="filter-icon-container">
				{count ? <div className="filter-count">{count}</div> : null}
				<Icon icon={iconFilter} description="More filters"/>
			</div>
		</Tooltip>
	</div>);
}